export class MultiSiteAnalysisInputModel {
    constructor(public environmentFactor?: number,
                public environmentGroupingFactor?: number,
                public genotypeFactor?: number,
                public selectedTraitIds?: number[],
                public instanceIds?: number[]
    ) {
    }
}
